import { useQuery } from '@tanstack/react-query'

import { CAR_STORY_QUERY_KEYS } from '../../lib'
import { type IGetNearestPlacesParams } from '../../model'
import { getCarStoryNearestPlaces } from '../request'

const useCarStoryNearestPlacesQuery = ({
  latitude,
  longitude,
}: IGetNearestPlacesParams) =>
  useQuery({
    queryKey: CAR_STORY_QUERY_KEYS.NEAREST_PLACES.list(latitude, longitude),
    queryFn: () => getCarStoryNearestPlaces({ latitude, longitude }),
    throwOnError: false,
  })

export default useCarStoryNearestPlacesQuery
